import { render, staticRenderFns } from "./ExcluirCancelarRegistro.vue?vue&type=template&id=1f7fb9e4&"
import script from "./ExcluirCancelarRegistro.vue?vue&type=script&lang=js&"
export * from "./ExcluirCancelarRegistro.vue?vue&type=script&lang=js&"
import style0 from "./ExcluirCancelarRegistro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports